// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__emI8s","tooltip":"IconButton_tooltip__jIUwF"};